import palette from './palette';

export default {
  styleOverrides: {
    root: {
      borderStyle: 'dashed'
    },
    vertical: {
      'borderColor': palette.grey.main
    }
  },
};
